// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"styles_ErrorPage__1MsX9","ErrorPage__error":"styles_ErrorPage__error__3G1JV"};